var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreLocator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 19.713,
    viewBox: "0 0 16.001 19.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3211",
    "data-name": "Group 3211",
    transform: "translate(-48.2 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M181.24,158.533v.66a.578.578,0,0,1-1.155,0v-.66h-1.319v.66a.578.578,0,0,1-1.155,0v-.66h-.761l-.49,4.412h6.133l-.49-4.412Z",
    transform: "translate(-123.225 -152.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M240.187,94.926a.66.66,0,1,0-1.319,0v.66h1.319v-.66Z",
    transform: "translate(-183.327 -90.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M56.2,0a8.01,8.01,0,0,0-8,8c0,6.728,7.065,11.246,7.7,11.63a.577.577,0,0,0,.594,0c.638-.383,7.7-4.9,7.7-11.63a8.01,8.01,0,0,0-8-8Zm4.142,11.479a.578.578,0,0,1-.43.192H52.489a.577.577,0,0,1-.574-.641l.619-5.567a.578.578,0,0,1,.574-.514h1.278v-.66a1.815,1.815,0,1,1,3.629,0v.66h1.278a.577.577,0,0,1,.574.514l.619,5.567A.577.577,0,0,1,60.342,11.479Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLocator1);
export default __webpack_public_path__ + "static/media/store_locator_1.0b54a370b0ba10fc5952f3ff3badd549.svg";
export { ForwardRef as ReactComponent };